import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import {
  Navbar as ResizableNavbar,
  NavBody,
  NavItems,
  MobileNav,
  MobileNavHeader,
  MobileNavToggle,
  MobileNavMenu,
} from './ui/resizable-navbar';
import { Logo } from './ui/Logo';

const navItems = [
  { name: 'Services', link: '/services' },
  { name: 'Solutions', link: '/solutions' },
  { name: 'Work', link: '/work' },
  { name: 'About', link: '/about' },
  { name: 'Insights', link: '/insights' },
  { name: 'Contact', link: '/contact' },
];

// Removed local Logo component as we now use the shared Logo component

export const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (link: string) => {
    setIsMobileMenuOpen(false);
    navigate(link);
  };

  return (
    <ResizableNavbar>
      {/* Desktop Navigation */}
      <NavBody>
        <Logo />
        <NavItems
          items={navItems}
          className="text-[#B7B7B2] hover:text-[#FBEAD7]"
          onItemClick={() => {}}
        />
        <div className="flex items-center gap-4">
          <motion.button
            onClick={() => navigate('/contact')}
            className="btn-primary !text-[10px] !py-1.5 !px-4"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            aria-label="Start a new project with us"
          >
            Start a Project
            <ArrowRight size={14} aria-hidden="true" />
          </motion.button>
        </div>
      </NavBody>

      {/* Mobile Navigation */}
      <MobileNav>
        <MobileNavHeader>
          <Logo />
          <MobileNavToggle
            isOpen={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          />
        </MobileNavHeader>

        <MobileNavMenu
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
          className="bg-[#121212] border border-[#FBEAD7]/10"
        >
          <div className="flex flex-col gap-6">
            <Logo />
            <p className="text-sm text-[#8B7F75] leading-relaxed max-w-xs">
              Architecting the future through engineering-led digital transformation and AI systems.
            </p>
          </div>
          {navItems.map((item, idx) => (
            <button
              key={`mobile-link-${idx}`}
              onClick={() => handleNavClick(item.link)}
              className={`block text-left text-lg font-medium transition-colors ${
                location.pathname === item.link
                  ? 'text-[#FBEAD7]'
                  : 'text-[#8B7F75] hover:text-[#FBEAD7]'
              }`}
            >
              {item.name}
            </button>
          ))}
          <div className="flex w-full flex-col gap-4 mt-6 pt-6 border-t border-[#FBEAD7]/10">
            <motion.button
              onClick={() => handleNavClick('/contact')}
              className="btn-primary w-full"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Start a Project
              <ArrowRight size={16} />
            </motion.button>
          </div>
        </MobileNavMenu>
      </MobileNav>
    </ResizableNavbar>
  );
};

export default Navbar;
